module.exports = __webpack_public_path__ + "img/b1003d3.svg";